/*
  Takes api error - determines if invalid payment method
*/
export default function isCardInvalid(error) {
  return Boolean(
    error?.graphQLErrors?.[0]?.extensions?.code &&
      (error.graphQLErrors[0].extensions.code === 'INVALID_PAYMENT_METHOD' ||
        error.graphQLErrors[0].extensions.code === 'CARD_DECLINED'),
  );
}
